<template lang="pug">
.coupons-item-open-container.flex-mid(
    v-if="info.type",
    :class="couponClass"
)
  .corner.flex-mid(v-if="info.corner")
    span.cornerTitle {{info.corner}}
  .top
    .price
      span.current {{ info.currentPrice | price }}
      span.unit 元
      span.intro(v-if="info.isExclusive && info.title") {{ info.title }}
      template(v-if="info.num && info.num > 1")
        span.multiple x
        span.count {{info.num}}
        span.page 张
  .bottom {{ info.isExclusive ? info.desc : info.title}}
</template>

<script>
import { VIP_BIZ } from '@/const/vip';

export default {
  filters: {
    price(val) {
      if (typeof val !== 'number') {
        return '';
      }

      return (Math.floor(val * 100) / 100);
    },
  },
  props: {
    info: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    couponClass() {
      const { isExclusive, type } = this.info;
      if (!isExclusive) {
        return `type-${type}`;
      }

      if (isExclusive && type === VIP_BIZ.BIKE) {
        return `exclusive-type-${this.info.num > 1 ? 'more' : type}`;
      }

      return 'default-exclusive-type';
    },
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.fontStyle(@lh: 0.22rem, @fs: 0.22rem, @fw: bold, @co: #d5261b) {
  line-height: @lh;
  font-size: @fs;
  font-weight: @fw;
  color: @co;
}

.omit() {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flex(@jc: center, @ai: center) {
  display: flex;
  justify-content: @jc;
  align-items: @ai;
}

.coupons-item-open-container {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  background-size: 100% 100%;

  .top {
    margin-top: 0.18rem;
    .flex();

    .price {
      max-width: 100%;
      .flex(center, baseline);

      .current {
        position: relative;
        top: 0.01rem;
        .fontStyle(0.22rem, 0.22rem, 500);
      }

      .unit {
        .fontStyle(0.17rem, 0.12rem);
      }

      .multiple {
        margin: 0 0.02rem;
        .fontStyle(0.12rem, 0.12rem, normal);
      }

      .count {
        .fontStyle(0.12rem, 0.14rem, 500);
      }

      .page {
        .fontStyle(0.12rem, 0.12rem);
      }
    }
  }

  .bottom {
    padding: 0.16rem 0 0.09rem 0;
    max-width: 100%;
    .omit();
    .fontStyle(0.12rem, 0.12rem, bold, #6e461b);
  }

  .corner {
    position: absolute;
    top: 0;
    left: 0;
    height: 0.16rem;
    background: #ffeec8;
    border-radius: 0.08rem 0 0.08rem 0;
    padding: 0.015rem 0.06rem;

    .cornerTitle {
      .fontStyle(0.14rem, 0.1rem, bold, #6e461b);
    }
  }

  &.exclusive-type-1 {
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/e028dfd4-8f58-43e8-8632-fb0c563a1b5b.png?x-oss-process=image/quality,q_80);
  }

  &.exclusive-type-more {
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/a0f58cfd-827d-42db-a33e-4d93c667b2b2.png);
  }

  &.default-exclusive-type {
    background-image: url(https://m.hellobike.com/resource/helloyun/15979/aArh02Li0F.png?x-oss-process=image/quality,q_80);
  }

  &.exclusive-type-1,
  &.exclusive-type-more,
  &.default-exclusive-type {
    .top {
      margin-top: 0.07rem;

      .price {
        .current {
          .fontStyle(0.22rem, 0.22rem, 500);
        }

        .unit,
        .intro {
          .fontStyle(0.14rem, 0.12rem);
        }

        .intro {
          .omit();
        }
      }
    }

    .bottom {
      padding: 0.04rem 0 0.13rem;
      .fontStyle(0.16rem, 0.11rem, 400, rgba(109,70,32,0.8));
    }
  }

  &.type-1 {
    background-image: url(https://m.hellobike.com/resource/helloyun/15979/Ysm9AInkMA.png?x-oss-process=image/quality,q_80);
  }

  &.type-2 {
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/b9be8eae-b8e5-419c-aab5-8e20b04e8ba8.png?x-oss-process=image/quality,q_80);
  }

  &.type-3 {
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/9131f5a3-c4fc-4f52-8fbd-955e86d69529.png?x-oss-process=image/quality,q_80);
  }

  &.type-4 {
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/26b1a020-2db1-42b8-8f77-cbab0b44895c.png?x-oss-process=image/quality,q_80);
  }

  &.type-5 {
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/a94f84a0-9af8-4996-89de-c1656b92c7a7.png?x-oss-process=image/quality,q_80);
  }

  &.type-6 {
    background-image: url(https://m.hellobike.com/resource/helloyun/a8376adcc22b4eeca338360fddf228e9/756203f4-c351-4cf8-b94e-a63487c7726a.png?x-oss-process=image/quality,q_80);
  }
}

</style>
